import React from 'react';
import { Link } from 'react-router-dom';
import './OurApproachSection.css';
import greenBullet from '../../assets/images/green-bullet.svg';

const OurApproachSection = () => {
  const approaches = [
    {
      number: '01',
      title: 'Partner',
      description: 'We invest more than capital. We recognize that in order to foster true alignment with our partners, we must have the same deep understanding of the market challenges, opportunities and nuances our businesses face.'
    },
    {
      number: '02',
      title: 'Strengthen',
      description: 'We support existing management teams with veteran operating professionals who have the proven business transformation capabilities and digital acumen necessary to fuel growth.'
    },
    {
      number: '03',
      title: 'Innovate',
      description: 'We empower strong companies to unlock the power of digital, using technology to optimize business processes in order to meet the demands of today\'s market.'
    },
    {
      number: '04',
      title: 'Drive',
      description: 'We believe this holistic approach has the ability to power an innovation flywheel, accelerating value creation for all stakeholders.'
    }
  ];

  return (
    <section className="our-approach-section">
        <div className="approach-header">
          <h2 className="section-label">
            <img src={greenBullet} alt="" className="bullet-image" />
            OUR APPROACH
          </h2>
          <div className="approach-title-container">
            <h3 className="section-headline">Private equity plus</h3>
            <div className="flourish">
              <div className="line"></div>
              <div className="ellipse"></div>
            </div>
          </div>
        </div>
        
        <div className="approaches-grid">
          {approaches.map((approach, index) => (
            <div className="approach-card" key={index}>
              <div className="approach-number">{approach.number}</div>
              <h4 className="approach-title">{approach.title}</h4>
              <p className="approach-description">{approach.description}</p>
            </div>
          ))}
        </div>
        
        <div className="approach-cta">
          <Link to="/approach" className="learn-more-link">
            LEARN MORE
            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M17.7387 12.6259L13.4506 17.0037C13.2898 17.1679 13.0754 17.25 12.861 17.25C12.6198 17.25 12.4054 17.1679 12.2446 17.0037C11.8961 16.6754 11.8961 16.1008 12.2446 15.7725L15.0586 12.8721H6.85762C6.37521 12.8721 6 12.4891 6 11.9966C6 11.5314 6.37521 11.121 6.85762 11.121H15.0586L12.2446 8.24805C11.8961 7.91971 11.8961 7.34511 12.2446 7.01678C12.5662 6.66107 13.129 6.66107 13.4506 7.01678L17.7387 11.3946C18.0871 11.723 18.0871 12.2976 17.7387 12.6259Z" fill="currentColor"/>
            </svg>
          </Link>
        </div>
    </section>
  );
};

export default OurApproachSection;
